module.exports = __webpack_public_path__ + "media/images/Yellow Main Header Background-b4453575c72bac8e7cf271fc46b49749.svg";